import axios from 'axios';
import {getCookie} from '@insticator/insticator-ui'; // iui-utils
import {url} from '../../../utils/urls';

const withCredentials = true;
const headers = {
  "Content-Type": "application/json",
  'Accept': 'application/json',
  'Authorization': `Bearer ${getCookie('pub_portal_user')}`
};


export const approveArticleSentimentV2Access = (accountUUID) => axios.post(`${url.ppa.url}/v1/accounts/${accountUUID}/product-access-requests`, { 'productType': 'ARTICLE_SENTIMENT_V2' }, { withCredentials });

export const fetchArticleSentimentV2Config = ({ siteUUID }) => axios.get(`${url.asu.url}/pub-portal/v2/sites/${siteUUID}/configs`, { withCredentials });

export const updateArticleSentimentV2Config = ({ unitUUID, data, section = 'general' }) => axios.put(`${url.asu.url}/pub-portal/v2/article-sentiment-units/${unitUUID}/configs/${section}`, data, { headers, withCredentials });

export const updateArticleSentimentV2DisplayConfig = ({ siteId, data }) => axios.put(`${url.ppa.url}/v1/configs/displayConfig/articleSentiment?siteId=${siteId}`, data, { headers, withCredentials });

export const fetchEmojisCategories = () => axios.get(`${url.ppa.url}/v1/emojis/categories?filterV2=true`, { withCredentials });